import { createBehavior } from '@area17/a17-behaviors';

const modallink = createBehavior(
  'modallink',
  {
    onClick(evt) {
      evt.preventDefault();
      this.$node.dispatchEvent(
        new CustomEvent('modal-link:clicked', {
          bubbles: true,
          detail: {
            id: this.$node.getAttribute('href').slice(1),
          },
        })
      );
    },
  },
  {
    init() {
      this.$node.addEventListener('click', this.onClick);
    },
    destroy() {
      this.$node.removeEventListener('click', this.onClick);
    },
  }
);

export default modallink;
